<template>
	<div class="flex flex-col h-screen w-screen overflow-hidden">
		<MaintenancePanel ref="maintenancePanel" compact :show-if-status="['warning','in_progress']"/>

		<div class="flex flex-grow w-full min-h-0">
			<DashboardSidebar />

			<div class="flex flex-1 flex-col min-w-0">
				<DashboardHeader @contactUsClicked="showContactUs = true"/>

				<main class="flex-grow overflow-y-auto min-h-0">
					<div class="p-6">
						<slot></slot>
					</div>
				</main>
			</div>
		</div>
	</div>

	<Teleport to="html">
		<AddOrganizationModal :show="orgStore.getShowAddModal" @onShowContactUs="showContactUs=true" />
	</Teleport>

	<Teleport to="html">
		<ContactUsModal v-if="showContactUs" :show="showContactUs" :horizontal-alignment="ModalHorizontalAlignment.End" :vertical-alignment="ModalVerticalAlignment.Bottom" @dismiss="showContactUs = false" />
	</Teleport>

	<!-- Alert shown when user loses authentication -->
	<Teleport to="html">
		<MultiButtonModal
			:show="authStore.unAuthenticated"
			icon="alert"
			title="Session Timeout"
			message="Your session has expired. Please sign in again."
			:buttons="[
									new ModalButtonData(
										'Ok', () => { authStore.logout(true) }, ButtonType.Default, ButtonSize.Small
									)
								]"
		/>
	</Teleport>

	<Teleport to="html">
		<SessionTimeoutModal/>
	</Teleport>
</template>

<script setup lang="js">
import DashboardSidebar from '@/components/Dashboard/Sidebar/DashboardSidebar.vue'
import DashboardHeader from '@/components/Dashboard/Header/DashboardHeader.vue'
import { useDarkModeStore } from '@/stores/darkMode.js'
import { useAuthStore } from '@/stores/authStore.js'
import { useOrganizationStore } from '@/stores/organizationStore.js'
import ContactUsModal from '@/views/Contact/ContactUsModal.vue'
import { onBeforeMount, onMounted, ref } from 'vue'
import AddOrganizationModal from '@/views/Organizations/AddOrganizationModal.vue'
import router from '@/router/router.js'
import { Banner } from '@/models/utils/Toaster.js'
import { ModalButtonData } from '@/components/Alerts/ModalButtonData.js'
import { ButtonSize, ButtonType } from '@/components/Forms/Buttons/SubmitButtonConstants.js'
import MultiButtonModal from '@/components/Alerts/MultiButtonModal.vue'
import { ModalHorizontalAlignment, ModalVerticalAlignment } from '@/components/Alerts/ModalAlignment.js'
import SessionTimeoutModal from '@/components/Modals/SessionTimeoutModal.vue'
import MaintenancePanel from '@/components/Misc/MaintenancePanel.vue'

useDarkModeStore()
const orgStore = useOrganizationStore()
const authStore = useAuthStore()
const showContactUs = ref(false)

const banner = new Banner();

onBeforeMount(() => {
	banner.clear()
})

//Moved here from DashboardPage to try and force user to set an organization
onMounted(() =>
{
	const user = authStore.getAuth?.user()
	const hasOrgs = authStore.userActiveOrganizationCount > 0 //userOrganizations.length
	const hasActiveOrg = authStore.activeOrganizationId > 0

	if (!user?.given_name || !user?.family_name || !user?.phone_number)
	{
		router.push({ name: 'auth.add-profile-info' }) //'auth.before-we-continue'
		return
	}

	if (hasOrgs && !hasActiveOrg)
	{
		orgStore.toggleChooseModal(true)
	}
	else if (!hasOrgs)
	{
		orgStore.showNoOrgModal()
	}
})
</script>
